module.exports = __webpack_public_path__ + "assets/img/collection1.17aa37d5.svg";